import React, { useState, useEffect, useRef } from 'react';
import CommonNav from './CommonNav'
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import SubDropdown from './SubDropdown';
import GroupsDropdown from './GroupsDropdown';
//import MultiSelectSub from './MultiSelectSub';
import SubstituteGroupsViewer from './SubstituteGroupsViewer';
import { Card } from 'primereact/card';
import subSchedule from '../mock/subschedulelist.json';
import { Button } from 'primereact/button';
import { ListBox } from 'primereact/listbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Endpoints } from "../constants/env/middletier";

import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { FloatLabel } from 'primereact/floatlabel';
import { Dialog } from 'primereact/dialog';
import { useKeycloak } from "@react-keycloak/web";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from "react-router-dom";
import { Panel } from 'primereact/panel';
import { useSearchParams } from "react-router-dom";

function RescheduleCanceledJob() {
    const [date, setDate] = useState('');
    const [dates, setDates] = useState([]);
    const [selectedSub, setSelectedSub] = useState(null);
    const [retryMessageAndCreateJob, setRetryMessageAndCreateJob] = useState(null);
    const [retrySubs, setRetrySubs] = useState(null);
    const [subJobStartDate, setSubJobStartDate] = useState(null);
    const [subJobDetailsHeader, setSubJobDetailsHeader] = useState(null);
    const [subJobEndDate, setSubJobEndDate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const substituteJobId = searchParams.get("substitute_job_id");
    const excludeSubstituteId = searchParams.get("exclude_sub_id");




    const [selectedGroup, setSelectedGroup] = useState(null);
    const [disabledDates, setDisabledDates] = useState(null);
    const [filteredById, setFilteredById] = useState([]);
    const [message, setMessage] = useState('');
    const [subPhoneNumbers, setSubPhoneNumbers] = useState([]);
    const [selectedSubs, setSelectedSubs] = useState([]);
    const [result, setResult] = useState([]);
    const stepperRef = useRef(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [description, setDescription] = useState('');
    const [notes, setNotes] = useState('');
    const [editNotesMode, setEditNotesMode] = useState(true);
    const [editDescriptionMode, setEditDescriptionMode] = useState(false);

    const { keycloak, initialized } = useKeycloak();
    console.log("Authenticated:", keycloak.authenticated);
    console.log("Token:", keycloak.token);
    console.log("Initialized:", initialized);
    const userId = keycloak.tokenParsed.sub;
    const userFullName = keycloak.tokenParsed.name;
    const userSchoolId = keycloak.tokenParsed.school_id;
    const userSubjects = keycloak.tokenParsed.subjects;


    const userPhoneNumber =
        keycloak?.tokenParsed?.phone_number?.replace(/\D/g, "");

    const [showMessageSent, setShowMessageSent] = useState(false);
    const navigate = useNavigate();

    console.log("userPhoneNumber:", userPhoneNumber);
    console.log("User ID:", userId);
    console.log("Token parsed:");
    console.log(keycloak.tokenParsed);

    if (!initialized) {
        return <div>Loading Keycloak...</div>;
    }

    if (!keycloak.authenticated) {
        return (
            <div>
                <p>Please log in to access this page.</p>
                <button onClick={() => keycloak.login()}>Login</button>
            </div>
        );
    }


    const fetchUserInfo = async () => {
        if (!keycloak?.token) return null;

        const response = await fetch(
        `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/userinfo`,
        {
            headers: {
                Authorization: `Bearer ${keycloak.token}`,
            },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch user info");
        }

        const keycloakData = await response.json();





//        const messageAndCreateJob = {
//            "subs": selectedSubs,
//            "subJobRequested": {
//                "teacherId": userId,
//                "teacherFullName": userFullName,
//                "teacherPhoneNumber": userPhoneNumber,
//                "startDate": dates[0],
//                "endDate": dates[1],
//                "description": description,
//                "notes": notes,
//                "subjectId": 2,
//                "status": "pending",
//                "schoolId": userSchoolId,
//            },
//            "jobDetails": userSubjects
//        };
//
//
//        setRetryMessageAndCreateJob(messageAndCreateJob);

        return await response.json();
    };



  useEffect(() => {
    async function fetchSubJob() {
      try {
        const res = await fetch(Endpoints["getsubjob"] + substituteJobId);
        const data = await res.json();
        console.log("subJob");
        console.log(data);

        const invitationsResponse = await fetch(Endpoints["getinvitations"] + substituteJobId);
        const invitationsData = await invitationsResponse.json();
        console.log("invitationsData");
        console.log(invitationsData);

        const filteredInvitationsData = invitationsData.filter(item => item.substituteId.toString() !== excludeSubstituteId);
        console.log("filteredInvitationsData");
        console.log(filteredInvitationsData);
        console.log(excludeSubstituteId);

        const availableSubs = await Promise.all(
            filteredInvitationsData.map(item =>
                fetch(Endpoints["subsbasicinfo"] + item.substituteId)
                .then(res => res.json())
            )
        );
        console.log("availableSubs");
        console.log(availableSubs);


        const messageAndCreateJob = {
            "subs": availableSubs,
            "subJobRequested": {
                "teacherId": data.teacherId,
                "teacherFullName": data.teacherFullName,
                "teacherPhoneNumber": data.teacherPhoneNumber,
                "startDate": data.startDate,
                "endDate": data.endDate,
                "description": data.description,
                "notes": data.notes,
                "subjectId": data.subjectId,
                "status": "pending",
                "schoolId": data.schoolId,
            },
            "jobDetails": userSubjects
        };
        console.log("messageAndCreateJob");
        console.log(messageAndCreateJob);
        setRetrySubs(availableSubs);

        const formattedStart = new Date(data.startDate).toLocaleDateString('en-US', {
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        });

        const formattedEnd = new Date(data.endDate).toLocaleDateString('en-US', {
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        });

        const jobDetailHeader = formattedStart + " - " + formattedEnd;

        setSubJobDetailsHeader(jobDetailHeader);
        setRetryMessageAndCreateJob(messageAndCreateJob);
        setSubJobStartDate(jobDetailHeader);
        setSubJobEndDate(data.endDate);

      } catch (err) {
        console.error("Failed to load groups", err);
      } finally {
        setLoading(false);
      }
    }
    fetchSubJob();
  }, []);


    const handleChildData = (data) => {
        const subPhoneNumbersMapped = data.map((teacher) => (teacher.phone));
        console.log(subPhoneNumbersMapped);
        setSubPhoneNumbers(subPhoneNumbersMapped);
        setSelectedSubs(data);
        console.log("Setting data");
        console.log(subPhoneNumbersMapped);
    };

    const handleGroupsDropdownChange = (data) => {
        console.log("Setting group dropdown");
        console.log(data);
        setSelectedGroup(data.id);
    };

    const handleSubChange = (sub) => {
        setSelectedSub(sub);
        const filteredBySub = subSchedule.filter(item => item.id === sub?.id.toString());
        setFilteredById(filteredBySub);
    };

    const handleGetPhoneNumbers = () => {
        console.log("Getting phone numbers");
        console.log(subPhoneNumbers);
    };

    const handleLogout = () => {
        keycloak.logout({
            redirectUri: window.location.origin
        });
    };

    const handleCalendarChange = (d) => {
        const value = d.value;
        setDates(value);
        console.log("Getting dates 1");
        console.log(value);


        // When range has both start and end dates → close calendar
        if (value && value.length === 2 && value[0] && value[1]) {
            setCalendarVisible(false);
        }


    };

    const handleGetAvailableSubs = async () => {

        console.log("Getting dates 2");

        const format = (date) => date?.toISOString().split("T")[0];

        const start = format(dates?.[0]); // "2025-11-01"
        const end = format(dates?.[1]);   // "2025-11-15"



//        const url = 'http://localhost:8080/substitutes/available?start=${start}&end=${end}';

        console.log("Calling:");
        try {
            const response = await fetch(Endpoints["getavailablesubs"] + `?start=${start}&end=${end}&groupId=${selectedGroup}`, {
                method: "GET"
            });
            if (!response.ok) throw new Error("Bad response");
            const data = await response.json();
            setResult(data);
            setSelectedSubs(data);
            console.log(data);
        } catch (err) {
            console.error(err);
        }

        const userinfo = await fetchUserInfo();

        console.log("userinfo");
        console.log(userinfo);

        console.log(start);
        console.log(end);
        stepperRef.current.nextCallback();
    };





    const handleSendRequests = async () => {
        console.log("handleSendRequests");

        console.log(selectedSubs);
        selectedSubs.forEach((sub, index) => {
            sub.phone = sub.phone.replace(/\D/g, "");
            console.log(`Sub at index ${index}: ${sub.phone}`);
        });
        const storedUser = JSON.parse(localStorage.getItem("user"));
        console.log(storedUser);
//    const userPhoneNumber =
//        keycloak?.tokenParsed?.phone_number?.replace(/\D/g, "");


        retryMessageAndCreateJob.subs = selectedSubs;

//        const messageAndCreateJob = {
//            "subs": selectedSubs,
//            "subJobRequested": {
//                "teacherId": userId,
//                "teacherFullName": userFullName,
//                "teacherPhoneNumber": userPhoneNumber,
//                "startDate": dates[0],
//                "endDate": dates[1],
//                "description": description,
//                "notes": notes,
//                "subjectId": 2,
//                "status": "pending",
//                "schoolId": userSchoolId,
//            },
//            "jobDetails": userSubjects
//        };
        console.log(retryMessageAndCreateJob);


        try {
          const response = await fetch(Endpoints["messageandcreatejob"], {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(retryMessageAndCreateJob),
          });

          const result = await response.json();
          console.log("Success:", result);
        } catch (error) {
          console.error("Error sending messages:", error);
        } finally {
            setShowMessageSent(true);
        }
    };



    const data_table_header = (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <span className="text-xl text-900 font-bold">{subJobDetailsHeader} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </div>
    );


    const data_table_footer = (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <Button label="Send Request" onClick={handleSendRequests} icon="pi pi-send" rounded iconPos="right" />
        </div>
    );


    const dateTemplate = (dateMeta) => {
        const isDisabled = disabledDates.some(
            d =>
                d.getFullYear() === dateMeta.year &&
                d.getMonth() === dateMeta.month &&
                d.getDate() === dateMeta.day
        );

        return (
            <span style={ isDisabled ? { color: "red" } : {} }>
                {dateMeta.day}
            </span>
            );
    };

    const handleRequestComplete = () => {
        if (!showMessageSent)
            return;

        console.log("navigate");
        console.log(navigate);
        navigate("/requestsub");
//        setShowMessageSent(false);

    };

    const showMessageSentfooterContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={handleRequestComplete} autoFocus />
        </div>
    );


//                                    <div className="flex gap-3">
//
//                                        {!editDescriptionMode && <Button onClick={() => setEditDescriptionMode(!editDescriptionMode)}
//                                        icon="pi pi-user-edit" text>&nbsp;Add Description</Button>}
//
//                                        {editDescriptionMode && <FloatLabel>
//                                            <InputTextarea id="description" autoResize maxLength={255} value={description} onChange={(e) => setDescription(e.target.value)} rows={5} cols={50} />
//                                            <label htmlFor="description">Description</label>
//                                        </FloatLabel>}
//                                    </div>




    return (
    <>
        <CommonNav></CommonNav>
        <br />
        <br />
    <div className="card flex justify-content-center">

        <Card title="Reschedule Job">
            <DataTable value={retrySubs} selectionMode={null} selection={selectedSubs}
                header={data_table_header} footer={data_table_footer}
                onSelectionChange={(e) => setSelectedSubs(e.value)}
                scrollable scrollHeight="250px" dataKey="id">

                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                <Column field="fullName" header="Name"></Column>
                <Column field="phone" header="Phone"></Column>
            </DataTable>
        </Card>



    </div>
    <div className="card">
        <Dialog header="Success" footer={showMessageSentfooterContent} visible={showMessageSent} style={{ width: '25vw' }} onHide={handleRequestComplete}>
            <p className="m-0">
                Request has been sent
            </p>
        </Dialog>
    </div>
    </>
    );
}

export default RescheduleCanceledJob;